import { SET_SYSTEM_BANNERS, DISMISS_SYSTEM_BANNER, CLEAR_DISMISSED_BANNERS } from "../Actions/systemBannerActionTypes";
import { SystemBanner } from "Network/Core/SystemBanners/systemBanners";
import { getLocalStorage, setLocalStorage } from "Network/ApiService";
import { ls_vars } from "Library/Constants";

interface SystemBannerState {
  banners: SystemBanner[];
  dismissedBanners: number[];
}

// Get dismissed banners for the current project
const getDismissedBanners = (): number[] => {
  try {
    const projectRef = getLocalStorage(ls_vars.PROJECT_REF);
    if (!projectRef) {
      return [];
    }
    
    const storageKey = `dismissedSystemBanners_${projectRef}`;
    const dismissed = localStorage.getItem(storageKey);
    
    if (!dismissed) {
      return [];
    }
    
    try {
      return JSON.parse(dismissed);
    } catch (parseError) {
      return [];
    }
  } catch (error) {
    return [];
  }
};

const initialState: SystemBannerState = {
  banners: [],
  dismissedBanners: getDismissedBanners(),
};

const systemBannerReducer = (state = initialState, action: any): SystemBannerState => {
  switch (action.type) {
    case SET_SYSTEM_BANNERS:
      return {
        ...state,
        banners: action.payload,
      };
    case DISMISS_SYSTEM_BANNER:
      const updatedDismissed = [...state.dismissedBanners, action.payload];
      
      // Save dismissed banners for the current project
      const projectRef = getLocalStorage(ls_vars.PROJECT_REF);
      if (projectRef) {
        const storageKey = `dismissedSystemBanners_${projectRef}`;
        setLocalStorage(storageKey, JSON.stringify(updatedDismissed));
      }
      
      return {
        ...state,
        dismissedBanners: updatedDismissed,
      };
    case CLEAR_DISMISSED_BANNERS:
      const currentProjectRef = getLocalStorage(ls_vars.PROJECT_REF);
      if (currentProjectRef) {
        const storageKey = `dismissedSystemBanners_${currentProjectRef}`;
        setLocalStorage(storageKey, JSON.stringify([]));
      }
      
      return {
        ...state,
        dismissedBanners: [],
      };
    default:
      return state;
  }
};

export default systemBannerReducer;
